import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconHamburger(props: SvgIconProps) {
  return (
    <SVGIcon width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 9H14" stroke="currentColor" strokeWidth="2" />
      <path d="M0 5L14 5" stroke="currentColor" strokeWidth="2" />
      <path d="M0 1L14 1" stroke="currentColor" strokeWidth="2" />
    </SVGIcon>
  );
}
